// extracted by mini-css-extract-plugin
export var colorStyle = "BuildInfo-module__colorStyle___0nxh0";
export var container = "BuildInfo-module__container___4PQPz";
export var linkBig = "BuildInfo-module__linkBig___sLhJO";